<template>
  <div :style="containerBg" class="floor5-container">
    <title-item :title="titleList[4]"></title-item>

    <ul class="item-container clearfix">
      <li v-for="(temp, index) in floorData" :key="'miva'+index" class="item-box">
        <div class="img-box">
          <img :src="temp.img" alt>
        </div>
        <div class="txt">{{temp.txt}}</div>
      </li>
    </ul>
  </div>
</template>

<script>
import data from "@/data/index.json";

export default {
  props: {
    floorData: {
      type: Array,
      default() {
        return [
          {
            img: require("@/assets/img/ceshi.png"),
            txt:
              "可就网站、小程序、公众号等技术需求进行沟通，是否承接及具体内容以书面确认为准"
          },
          {
            img: require("@/assets/img/ceshi1.png"),
            txt:
              "沟通过程通常包括需求沟通、方案确认、界面确认、开发实施、联调测试和交付确认，实际流程根据项目约定调整"
          },
          {
            img: require("@/assets/img/ceshi2.png"),
            txt:
              "项目交付范围、周期和后续支持内容，以双方签署的合同及确认文件为准"
          }
        ];
      }
    }
  },
  data() {
    return {
      titleList: data.titleList,
      containerBg: `background-image: url(${require("@/assets/img/floor5Bg.png")})`
    };
  }
};
</script>

<style lang="less" scoped>
.floor5-container {
  margin: 50px 0;
  padding-bottom: 50px;
}

.item-box {
  width: 100%/3;
  float: left;
  padding: 10px;
  color: #fff;
  .txt {
    padding: 20px 0;
  }
  @media (max-width: 768px) {
    & {
      width: 100%;
      padding: 15px;
    }
  }
}
</style>
